import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from '../../../setup'
import { listReset } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'

const TimeInfoStyled = styled.div`
  display: flex;
`

const TimeInfoIconStyled = styled.div`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
`

const TimeInfoContentStyled = styled.div`
  display: flex;
  flex-direction: column;
`

const TimeInfoTitleStyled = styled(Text)`
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`

const TimeInfoValueStyled = styled(Text)``

export { TimeInfoStyled, TimeInfoIconStyled, TimeInfoContentStyled, TimeInfoTitleStyled, TimeInfoValueStyled }
